import { Header } from "../../components/Header/header";
import { PerfilStyled } from "./styles";
import { Container } from "../../assets/styles/Container";
import { Button } from "../../components/Button/button";
import { Input } from "../../assets/styles/Input";
import { useForm } from "react-hook-form";
import {
	iResetPassword,
	resetPasswordSchema,
} from "./FormSchema/password.schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useContext, useEffect } from "react";
import { UserContext } from "../../providers/UserContext";
import { useParams } from "react-router-dom";

export const ResetPassword = () => {
	const { resetSenha } = useContext(UserContext);
	const { token } = useParams<{ token: string }>();

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
	} = useForm<iResetPassword>({ resolver: zodResolver(resetPasswordSchema) });

	useEffect(() => {
		if (token) {
			setValue("token", token);
		}
	}, [token, setValue]);

	const submitResetPassword = (resetPasswordData: iResetPassword) => {
		resetSenha(resetPasswordData);
	};

	return (
		<>
			<Header />
			<Container>
				<PerfilStyled>
					<div className="card">
						<h1>Recuperar senha</h1>
						<form method="post" onSubmit={handleSubmit(submitResetPassword)}>
							<Input
								type="password"
								{...register("password")}
								id="password"
								placeholder="Nova senha"
								alt="Nova senha"
							/>
							{errors.password && <span>{errors.password.message}</span>}
							<abbr title="Recuperar">
								<Button type="submit">Recuperar</Button>
							</abbr>
						</form>
					</div>
				</PerfilStyled>
			</Container>
		</>
	);
};
